import { exec, getApiToken } from '../utils';
import type {
  Partner,
  FetchPartnersArgs,
} from '@src/types';

export const fetchPartners = async ({ permissionCodes, token }: FetchPartnersArgs): Promise<Partner[]> => {
  const apiToken = await getApiToken(token);

  const query = `
    query getPartners (
      $permissionCodes: [String]
      $token: String!
    ) {
      user(token: $token) {
        partners(
          permissionCodes: $permissionCodes
          showOnlyActive: true
          sortOrder: "name"
        ) {
          id
          code
          name
          uuid
          displayName
        }
      }
    }
  `;

  interface UserResponse {
    user: {
      partners: Partner[];
    };
  }

  const data = await exec<{ permissionCodes: string[], token: string }, UserResponse>(
    query, {
    variables: {
      permissionCodes,
      token: apiToken,
    },
  },
  );

  return data.user.partners;
};
